import { LoggedInActionButtons } from '@/modules/LandingHeaderV2/components/LoggedInActionButtons/LoggedInActionButtons';
import { LoggedOutActionButtons } from '@/modules/LandingHeaderV2/components/LoggedOutActionButtons/LoggedOutActionButtons';
import { useUserDisplayInfo } from '@/modules/LandingHeaderV2/hooks/useUserDisplayInfo';

export type NavbarActionButtonsProps = {
  isSmallScreen: boolean;
  onRegisterClick?: () => void;
  onSignInClick?: () => void;
  signInUrl?: string;
  registerUrl?: string;
};

export const NavbarActionButtons = ({
  onRegisterClick,
  onSignInClick,
  signInUrl,
  registerUrl,
  isSmallScreen,
}: NavbarActionButtonsProps) => {
  const { user, userInitials, isUserLoggedIn } = useUserDisplayInfo();

  return isUserLoggedIn ? (
    <LoggedInActionButtons
      isSmallScreen={isSmallScreen}
      givenName={user?.given_name}
      userInitials={userInitials}
    />
  ) : (
    <LoggedOutActionButtons
      onSignInClick={onSignInClick}
      onRegisterClick={onRegisterClick}
      signInUrl={signInUrl ?? ''}
      registerUrl={registerUrl ?? ''}
      isSmallScreen={isSmallScreen}
    />
  );
};
